import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel,ConfigurationPanel } from '.';

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: null,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    /*createConfig:     {
        group: 'Devices',
        name: "Multisensor",
        description: "Multisensor",
        panel: OverviewPanel,
    },*/
}